/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CiEdit } from "react-icons/ci";
import { FaPlus } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import AddPatient from "../../components/modal/AddPatient";
import EditBillingAddress from "../../components/modal/EditBillingAddress";
import LoadWallet from "../../components/modal/LoadWallet";
import SendNotification from "../../components/modal/SendNotification";
import Appointment from "../../components/tables/Appointment";
import ConsumerPatientList from "../../components/tables/ConsumerPatientList";
import { DeleteApiCaller, getApiCaller } from "../../libs/apiCaller";
import { useUnauthorizedNavigation } from "../../libs/UnauthorisedPage";
import { setConsumerProfile } from "../../redux/slices/consumerSlice";

const ConsumerProfile = () => {
  const [appointmentActiveTab, setAppointmentActiveTab] = useState("Scheduled");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPatientDelete, setIsPatientDelete] = useState(false);
  const [billingAddressModalOpen, setBillingAddressModalOpen] = useState(false);
  const [patientId, setPatientId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sendNotificationModalOpen, setSendNotificationModalOpen] =
    useState(false);
  const [profileInfo, setProfileInfo] = useState({});
  const [patientData, setPatientData] = useState({});
  const [scheduleArray, setScheduleArray] = useState([]);
  const [completedArray, setCompletedArray] = useState([]);
  const [cancelledArray, setCancelledArray] = useState([]);
  const [patientsArray, setPatientsArray] = useState([]);
  const redirectToLogin = useUnauthorizedNavigation();
  const dispatch = useDispatch();
  const [amount, setAmount] = useState(0);
  const [loadWalletModal, setLoadWalletModal] = useState(false);
  const [isLoadingLoadWallet, setIsLoadingLoadWallet] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const { id } = useParams();
  const navigate = useNavigate(); // Hook to programmatically navigate

  useEffect(() => {
    getConsumerDetails();
  }, []);

  const getConsumerDetails = async () => {
    setIsLoading(true);
    const endPoint = `consumer_details?consumer_id=${id}`;
    try {
      const response = await getApiCaller(endPoint);
      const reposneData = response?.data?.response_data?.[0];
      if (response?.data?.response_code === 200) {
        dispatch(setConsumerProfile(reposneData?.profile_info));
        setProfileInfo(reposneData?.profile_info);
        setPatientsArray(reposneData?.patients);
        setScheduleArray(reposneData?.appointment_array?.Scheduled);
        setCompletedArray(reposneData?.appointment_array?.Completed);
        setCancelledArray(reposneData?.appointment_array?.Cancelled);
      }
    } catch (error) {
      toast.error("Failed to fetch data.");
    }
    setIsLoading(false);
  };

  const handleTabClick = (tab) => {
    setAppointmentActiveTab(tab);
  };

  // Determine the data based on active tab
  const getFilteredAppointments = () => {
    if (appointmentActiveTab === "Scheduled") return scheduleArray;
    if (appointmentActiveTab === "Completed") return completedArray;
    return cancelledArray;
  };

  const handleDeletePatient = async (id) => {
    setIsPatientDelete(true);
    const endPoint = `delete_patient?patient_id=${id}`;
    const response = await DeleteApiCaller(endPoint);

    if (response.data.response_code === 200) {
      getConsumerDetails();
      toast.success(response.data.response_message);
      onClose();
    } else if (response.response.data.response_code === 403) {
      redirectToLogin();
    } else {
      toast.error(response.data.response_message);
    }
    setIsPatientDelete(false);
  };

  const onClose = () => {
    setPatientId("");
    setIsModalOpen(false);
    setPatientData({});
  };

  const handleMakePayment = async (amount) => {
    try {
      setIsLoadingLoadWallet(true);
      const endPoint = `admin_add_balance_user?user_id=${
        profileInfo?.id
      }&amount=${String(amount)}&type=${
        selectedIndex === 0 ? "increase" : "decrease"
      }`;
      const response = await getApiCaller(endPoint);
      if (response?.data.response_code === 200) {
        toast.success(response.data.response_message);
        setLoadWalletModal(false);
      } else {
        toast.error(response?.data?.response_message);
      }
    } catch (error) {
      console.log("error", error);
      toast.error(error?.message);
    } finally {
      setIsLoadingLoadWallet(false);
    }
  };

  return (
    <>
      {isLoading && (
        <div className="text-center flex items-center justify-center my-10 h-[70vh]">
          <PropagateLoader color="#284184" loading={true} size={10} />
        </div>
      )}
      {!isLoading && (
        <>
          <div className="px-4 md:px-10 mt-4">
            <nav className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-2">
                <Link
                  to="/consumer"
                  className="text-[#284184] text-xl hover:underline"
                >
                  All Consumers
                </Link>
                <span className="text-[#284184]">/</span>
                <span className="text-[#284184] text-xl font-bold">
                  {profileInfo?.first_name} {profileInfo?.last_name}
                </span>
              </div>
              <div className="flex space-x-3">
                <button
                  className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
                  onClick={() => setLoadWalletModal(true)}
                  disabled={isLoadingLoadWallet}
                >
                  {isLoadingLoadWallet ? "Loading..." : "Load Wallet"}
                </button>
                <button
                  className="bg-blue-700 text-white px-4 py-2 rounded-md hover:bg-blue-800"
                  onClick={() => setSendNotificationModalOpen(true)}
                >
                  Send Notification
                </button>
              </div>
            </nav>
            <div className="border border-1 px-4 py-3 rounded-t-2xl text-xl mt-4 bg-white">
              <div className="flex justify-between">
                <p className="text-[#284184] font-bold">Profile Info</p>
                <button
                  className="text-[#E0A256] text-base flex items-center space-x-1"
                  onClick={() =>
                    navigate("/editProfile", { state: { profileInfo } })
                  }
                >
                  <CiEdit size={20} />
                  <span className="underline">Edit Info</span>
                </button>
              </div>
            </div>
            <div className="border border-t-0 rounded-b-2xl px-4 py-4 bg-white">
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div className="col-span-1">
                  <div className="flex items-center space-x-4">
                    <div className="rounded-xl bg-gray-200 flex items-center justify-center">
                      <img
                        src={
                          profileInfo?.profile_picture ||
                          `https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqafzhnwwYzuOTjTlaYMeQ7hxQLy_Wq8dnQg&s`
                        }
                        alt={"profile"}
                        className="w-24 h-24 rounded-xl object-cover border border-gray-300"
                      />
                    </div>
                    <div className="">
                      <div className="text-sm text-gray-500">
                        Total Spending
                      </div>
                      <div className="font-semibold">
                        ${profileInfo?.total_spending || 0}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-span-1 content-center">
                  <div className="text-sm text-gray-500">Wallet Balance</div>
                  <div className="font-semibold">
                    ${profileInfo?.wallet_balance || 0}
                  </div>
                </div>
                <div className="content-center">
                  <Link
                    to={`/consumerProfile/wallet/${id}`}
                    className="text-blue-600 hover:underline text-sm"
                  >
                    View Wallet
                  </Link>
                </div>
              </div>
              {/* personal detail */}
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                <div>
                  <label className="text-sm text-gray-500">First Name</label>
                  <div className="font-medium">
                    {profileInfo?.first_name || "-"}
                  </div>
                </div>
                <div>
                  <label className="text-sm text-gray-500">Last Name</label>
                  <div className="font-medium">
                    {profileInfo?.last_name || "-"}
                  </div>
                </div>
                <div>
                  <label className="text-sm text-gray-500">Email Address</label>
                  <div className="font-medium">{profileInfo?.email || "-"}</div>
                </div>
                <div>
                  <label className="text-sm text-gray-500">Mobile Number</label>
                  <div className="font-medium">
                    {profileInfo?.country_code} {profileInfo?.number || "-"}
                  </div>
                </div>
              </div>
            </div>
            {/* Patient List */}
            <div className="border border-1 px-4 py-3 rounded-t-2xl text-xl mt-4 bg-white">
              <div className="flex justify-between">
                <p className="text-[#284184] font-bold">Patient List</p>
                <button
                  className="text-[#E0A256] text-base flex items-center space-x-1"
                  onClick={() => setIsModalOpen(true)}
                >
                  <FaPlus />
                  <span className="underline">Add Patient</span>
                </button>
              </div>
            </div>
            <div className="border border-t-0 rounded-b-2xl px-4 py-4 bg-white">
              <ConsumerPatientList
                setPatientId={setPatientId}
                setIsModalOpen={setIsModalOpen}
                patientsArray={patientsArray}
                setPatientData={setPatientData}
              />
            </div>
            {/* Billing Address */}
            <div className="border border-1 px-4 py-3 rounded-t-2xl text-xl mt-4 bg-white">
              <div className="flex justify-between">
                <p className="text-[#284184] font-bold">Billing Address</p>
                <button
                  className="text-[#E0A256] text-base flex items-center space-x-1"
                  onClick={() => setBillingAddressModalOpen(true)}
                >
                  <CiEdit size={20} />
                  <span className="underline">Edit Address</span>
                </button>
              </div>
            </div>
            <div className="border border-1 border-t-0 rounded-b-2xl px-4 py-3 bg-white">
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Apt No.
                  </label>
                  <p className="text-base">
                    {profileInfo?.billing_apt_no || "-"}
                  </p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Address
                  </label>
                  <p className="text-base">
                    {profileInfo?.billing_street || "-"}
                  </p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Province/State
                  </label>
                  <p className="text-base">
                    {profileInfo?.billing_state || "-"}
                  </p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    City
                  </label>
                  <p className="text-base">
                    {profileInfo?.billing_city || "-"}
                  </p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Postal Code
                  </label>
                  <p className="text-base">
                    {profileInfo?.billing_postal_code || "-"}
                  </p>
                </div>
              </div>
            </div>
            {/* Appointments */}
            <div className="border border-1 px-4 py-3 rounded-t-2xl text-xl mt-4 bg-white">
              <p className="text-[#284184] font-bold">Appointments</p>
            </div>
            <div className="border border-1 border-t-0 rounded-b-2xl px-4 py-3 bg-white">
              <div className="flex w-full rounded-lg bg-[#F4F9FF] p-1.5 mb-3">
                {["Scheduled", "Completed", "Cancelled"].map((tab) => (
                  <button
                    key={tab}
                    className={`w-full px-4 py-2 text-[#80838D] rounded-lg text-left md:text-center ${
                      appointmentActiveTab === tab && "bg-[#284184] text-white"
                    }`}
                    onClick={() => handleTabClick(tab)}
                  >
                    {tab}
                  </button>
                ))}
              </div>
              <Appointment
                appointmentActiveTab={appointmentActiveTab}
                appointments={getFilteredAppointments()} // Pass filtered data
                consumerId={id}
              />
            </div>
          </div>
        </>
      )}
      <AddPatient
        isOpen={isModalOpen}
        onClose={() => onClose()}
        patientId={patientId}
        consumerId={id}
        patientData={patientData}
        setPatientData={setPatientData}
        getConsumerDetails={getConsumerDetails}
        handleDelete={handleDeletePatient}
        isPatientDelete={isPatientDelete}
      />
      <EditBillingAddress
        isOpen={billingAddressModalOpen}
        onClose={() => {
          setBillingAddressModalOpen(false);
        }}
        profileInfo={profileInfo}
        getConsumerDetails={getConsumerDetails}
      />
      <SendNotification
        isOpen={sendNotificationModalOpen}
        onClose={() => setSendNotificationModalOpen(false)}
        notificationMobileNumber={`${profileInfo?.country_code} ${
          profileInfo?.number || "-"
        }`}
        id={profileInfo.id}
      />
      <LoadWallet
        setAmount={setAmount}
        amount={amount}
        handleMakePayment={handleMakePayment}
        isOpen={loadWalletModal}
        onClose={() => {
          setLoadWalletModal(false);
          setSelectedIndex(0);
        }}
        isLoadingLoadWallet={isLoadingLoadWallet}
        setSelectedIndex={setSelectedIndex}
        selectedIndex={selectedIndex}
      />
    </>
  );
};

export default ConsumerProfile;
